import Icon from "@pdfking/workflow/components/Icon"
import proxy from "@pdfking/workflow/utils/proxy"
import { defineComponent } from "vue"
import user from "../state/user"

export default defineComponent({
  computed: proxy(user(), ["cart_counter"]),
  props: [] as const,
  render() {
    return (
      <div
        class={[
          "m-0 py-0",
          { "btn btn-sm btn-primary": (this.cart_counter as number) > 0 },
        ]}
      >
        <Icon name="SHOPPING_CART" />
        {(this.cart_counter as number) > 0 && <span class="ms-1">{this.cart_counter}</span>}
      </div>
    )
  },
})
